export const ECounterpartyColumnKeys = {
  LogoUrl: 'logo_url',
  Name: 'name',
  Code: 'code',
  HoldingName: 'holding_name',
  Guid: 'guid',
  Description: 'description',
  Segment: 'segment',
  Status: 'status',
  Actions: 'actions',
} as const;

export const ECounterpartyStatus = {
  Closed: 0,
  Active: 1,
  Blocked: 2,
} as const;

export const ECounterpartyAction = {
  Edit: 'edit',
  Delete: 'delete',
} as const;

export const EQueryParams = {
  Page: 'page',
  PageSize: 'pageSize',
} as const;
